import { Button, Container } from '@mui/material';
import { useEffect } from 'react';
import { Helmet } from 'react-helmet';
import { Navigate, useNavigate, useParams } from 'react-router-dom';
import { COMPARISONS } from '../../data/comparisons';
import { logEvent } from '../../utils/ga';
import styles from './ComparePage.module.css';

function ComparePage() {
  const navigate = useNavigate();
  const { type } = useParams<{ type: string }>();
  const comparison = COMPARISONS.find((item) => item.id === type);

  useEffect(() => {
    if (type && comparison) {
      logEvent('compare', type, 'view');
    }
  }, [comparison, type]);

  if (!comparison) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className={styles.root}>
      <Helmet>
        <title>{comparison.metaTitle}</title>
        <meta name="description" content={comparison.metaDescription} />
      </Helmet>

      <Container maxWidth="md">
        <h1 className={styles.pageTitle}>{comparison.title}</h1>
        <p className={styles.commonQuestion}>{comparison.commonQuestion}</p>

        <div className={styles.verdictCard}>
          <p className={styles.verdictLabel}>결론</p>
          <p className={styles.verdictText}>{comparison.verdict}</p>
          <p className={styles.verdictDetail}>{comparison.verdictDetail}</p>
        </div>

        <div className={styles.compareCards}>
          {comparison.options.map((option) => (
            <div
              key={option.id}
              className={styles.optionCard}
              style={{ borderTop: `4px solid ${option.color}` }}
            >
              <p className={styles.optionName}>{option.shortName}</p>
              <p className={styles.optionBestFor}>{option.bestFor}</p>
              <ul className={styles.prosList}>
                {option.pros.map((pro) => (
                  <li key={pro}>✓ {pro}</li>
                ))}
              </ul>
              <ul className={styles.consList}>
                {option.cons.map((con) => (
                  <li key={con}>✗ {con}</li>
                ))}
              </ul>
              <div className={styles.optionMeta}>
                <span>세제혜택: {option.taxAdvantage}</span>
                <span>연간한도: {option.annualLimit}</span>
                <span>인출조건: {option.withdrawalCondition}</span>
              </div>
            </div>
          ))}
        </div>

        <div className={styles.tableWrapper}>
          <table className={styles.compareTable}>
            <thead>
              <tr>
                <th />
                <th>{comparison.options[0].shortName}</th>
                <th>{comparison.options[1].shortName}</th>
              </tr>
            </thead>
            <tbody>
              {comparison.comparisonTable.rows.map((row) => (
                <tr key={row.label}>
                  <td className={styles.rowLabel}>{row.label}</td>
                  <td>{row.a}</td>
                  <td>{row.b}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className={styles.relatedLinks}>
          {comparison.relatedLinks.map((link) => (
            <Button
              key={link.href}
              variant="contained"
              onClick={() => navigate(link.href)}
              sx={{ background: '#000033', '&:hover': { background: '#001166' } }}
            >
              {link.label} →
            </Button>
          ))}
        </div>
      </Container>
    </div>
  );
}

export default ComparePage;
